import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { CartContext } from './CartContext';
import Checkout from './Checkout';
import ProductList from './ProductList';
import ListUser from './manager/ListUser';
import Logout from './logout';
import Login from './Login';
import ProductDetail from './ProductDetail';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/app.css'

function App({ user }) {
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    // 從 localStorage 中讀取特定帳號的購物車內容
    const savedCartItems = localStorage.getItem(`${user}_cartItems`);
    if (savedCartItems) {
      setCartItems(JSON.parse(savedCartItems));
    }
  }, [user]);

  const handleLogout = () => {
    // 在登出時清除購物車內容和其他用戶相關的資料
    localStorage.removeItem(`${user}_cartItems`);
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    setCartItems([]);
    window.location.reload();
  };

  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const username = localStorage.getItem('username');

  return (
    <BrowserRouter>
      <CartContext.Provider value={{ cartItems, setCartItems }}>
        <nav>
          <Link to="/">首頁</Link>
          <Link to="/checkout">購物車</Link>
          <Link to="/manager/ListUser">管理者</Link>
          {isLoggedIn ? (
            <Link to="/" onClick={handleLogout}>登出 ({username})</Link>
          ) : (
            <Link to="/login">登入</Link>
          )}
        </nav>

        <Routes>
          <Route path="/" element={<ProductList />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/product" element={<ProductDetail/>}>
            <Route path=":id" element={<ProductDetail/>} />
          </Route>
          <Route path="/manager/ListUser" element={<ListUser />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<p>找不到頁面</p>} />
        </Routes>
      </CartContext.Provider>
    </BrowserRouter>
  );
}

export default App;
